export default __webpack_public_path__ + "static/media/ans-app-v3.0.d9ae911f.png";